import * as Constants from '../../../constants/action-constants';
import { EULADetails } from '../../../types/workflows/steps/Eula';
export interface InitializeStepEula {
  type: Constants.INITIALIZE_STEP_EULA;
}

export interface InitializeStepEulaSuccess {
  type: Constants.INITIALIZE_STEP_EULA_SUCCESS;
  payload: {
    eulaDetails: EULADetails;
  };
}

export interface InitializeStepEulaFailed {
  type: Constants.INITIALIZE_STEP_EULA_FAILED;
}

export type StepEulaAction =
  | InitializeStepEula
  | InitializeStepEulaFailed
  | InitializeStepEulaSuccess;

export const initializeStepEula = (): InitializeStepEula => ({
  type: Constants.INITIALIZE_STEP_EULA
});

export const initializeStepEulaSuccess = (
  eulaDetails: EULADetails
): InitializeStepEulaSuccess => ({
  payload: { eulaDetails },
  type: Constants.INITIALIZE_STEP_EULA_SUCCESS
});

export const initializeStepEulaFailed = (): InitializeStepEulaFailed => ({
  type: Constants.INITIALIZE_STEP_EULA_FAILED
});
